let lenis = null;

export const setLenis = (instance) => {
  lenis = instance;
};

export const scrollToId = (target) => {
  if (lenis) {
    lenis.scrollTo(target, { offset: -70, duration: 1.5 });
  } else {
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  }
};
